import { InvestmentDocumentType, InvestmentState } from "./types";

export const STATE_LABELS: Record<InvestmentState, string> = {
  [InvestmentState.PROSPECT]: "Prospecto",
  [InvestmentState.RESERVED]: "Reservado",
  [InvestmentState.FINANCING]: "Financiando",
  [InvestmentState.FUNDED]: "Financiado",
  [InvestmentState.DECLARED]: "Comunicado",
  [InvestmentState.CANCELLED]: "Cancelado",
  [InvestmentState.EXPIRED]: "Expirado",
  [InvestmentState.REJECTED]: "Rechazado",
};

export const DOCUMENT_LABELS: Record<InvestmentDocumentType, string> = {
  [InvestmentDocumentType.INVESTMENT_PROPOSAL]: "Propuesta de Inversión",
  [InvestmentDocumentType.RESERVATION_CONTRACT]: "Contrato de Reserva",
  [InvestmentDocumentType.FINANCING_CONTRACT]: "Contrato de Financiación",
  [InvestmentDocumentType.COMMUNICATION_CONTRACT]: "Contrato de Comunicación",
  [InvestmentDocumentType.PAYMENT_RECEIPT]: "Comprobante de Pago",
  [InvestmentDocumentType.TAX_SUBMISSION_CERTIFICATE]: "Justificante de Comunicación",
};

export const DOCUMENT_SHORT_LABELS: Record<InvestmentDocumentType, string> = {
  [InvestmentDocumentType.INVESTMENT_PROPOSAL]: "Propuesta",
  [InvestmentDocumentType.RESERVATION_CONTRACT]: "Reserva",
  [InvestmentDocumentType.FINANCING_CONTRACT]: "Financiación",
  [InvestmentDocumentType.COMMUNICATION_CONTRACT]: "Comunicación",
  [InvestmentDocumentType.PAYMENT_RECEIPT]: "Pago",
  [InvestmentDocumentType.TAX_SUBMISSION_CERTIFICATE]: "Justificante",
};
